// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AcceptableVerificationDocuments: MarkdocTagRegistration = {
  tag: 'acceptable-verification-documents',
  component: 'AcceptableVerificationDocuments',
  attributes: {
    acceptableDocs: {
      type: Array,
      default: [],
      description:
        'List of documents that can be submitted for verification in each country. This should come from the $acceptableVerificationDocuments context',
    },
    countries: {
      type: Array,
      default: [],
      description:
        'A map of ISO country code <> formatted country name. This should be $countries.payout_countries.',
    },
  },
};
